const CUR_SYM = { USD: "US$", CAD: "CA$", GBP: "£", EUR: "€" };
const money = (v, cur) => (v === null || v === undefined || v === "" ? "—" : `${CUR_SYM[cur] || "$"}${Number(v).toLocaleString(undefined, { minimumFractionDigits: 2 })}`);
const esc = (s) => String(s ?? "—").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
const totalsLine = (bucket) => {
  const e = Object.entries(bucket || {});
  return e.length ? e.map(([c, v]) => money(v, c)).join(" + ") : "—";
};

export function printCapitalReport({ fyText, totals, rows }) {
  const counts = { pending: 0, approved: 0, denied: 0 };
  rows.forEach((r) => { if (counts[r.status] !== undefined) counts[r.status] += 1; });
  const sorted = [...rows].sort((a, b) => String(b.created_at || "").localeCompare(String(a.created_at || "")));
  const body = sorted.map((r) => `<tr>
    <td>${esc(r.title)}${r.archived ? ' <span class="arch">ARCHIVED</span>' : ""}</td>
    <td>${esc(r.category)}</td>
    <td>${esc(r.priority)}</td>
    <td>${esc(r.created_by_name)}</td>
    <td>${esc(r.approver_name)}</td>
    <td>${esc((r.status || "").toUpperCase())}${r.decided_by_name ? `<div class="sub">by ${esc(r.decided_by_name)} · ${esc(String(r.decided_at || "").slice(0, 10))}</div>` : ""}</td>
    <td class="num">${money(r.estimated_cost, r.currency)}</td>
    <td>${esc(String(r.created_at || "").slice(0, 10))}</td>
  </tr>`).join("");
  const html = `<!doctype html><html><head><title>Capital Overview — Summary Report</title>
<style>
  body { font-family: Georgia, 'Times New Roman', serif; color: #111; margin: 40px; }
  .head { display: flex; justify-content: space-between; align-items: baseline; border-bottom: 3px solid #111; padding-bottom: 10px; }
  h1 { font-size: 20px; margin: 0; }
  .brand { font-size: 13px; letter-spacing: 2px; }
  .fy { margin-top: 10px; font-size: 12px; letter-spacing: 2px; text-transform: uppercase; color: #555; }
  table { width: 100%; border-collapse: collapse; margin-top: 16px; font-size: 12px; }
  th { border: 1px solid #999; padding: 6px 8px; background: #f4f4f4; font-size: 10px; text-transform: uppercase; letter-spacing: 1px; color: #555; text-align: left; }
  td { border: 1px solid #999; padding: 6px 8px; vertical-align: top; }
  td.num { text-align: right; font-variant-numeric: tabular-nums; white-space: nowrap; }
  .sum td.k { width: 140px; font-size: 10px; text-transform: uppercase; letter-spacing: 1px; color: #555; background: #f4f4f4; }
  .sub { font-size: 10px; color: #666; margin-top: 2px; }
  .arch { font-size: 9px; letter-spacing: 1px; color: #777; border: 1px solid #999; padding: 0 4px; }
  .foot { margin-top: 30px; font-size: 10px; color: #777; }
  @media print { body { margin: 16px; } }
</style></head><body>
  <div class="head"><h1>Capital Overview — Summary Report</h1><div class="brand">SA · TRACKER</div></div>
  <div class="fy">Fiscal year: ${esc(fyText)}</div>
  <table class="sum">
    <tr><td class="k">Pending</td><td>${counts.pending} request(s)</td><td class="num">${totalsLine(totals.pending)}</td></tr>
    <tr><td class="k">Approved</td><td>${counts.approved} request(s)</td><td class="num">${totalsLine(totals.approved)}</td></tr>
    <tr><td class="k">Denied</td><td>${counts.denied} request(s)</td><td class="num">${totalsLine(totals.denied)}</td></tr>
  </table>
  <table>
    <tr><th>Title</th><th>Category</th><th>Priority</th><th>Raised by</th><th>Approver</th><th>Status</th><th>Est. cost</th><th>Raised</th></tr>
    ${body || '<tr><td colspan="8">No requests in this fiscal year.</td></tr>'}
  </table>
  <div class="foot">Generated ${new Date().toISOString().slice(0, 16).replace("T", " ")} UTC · ${sorted.length} request(s)</div>
</body></html>`;
  const w = window.open("", "_blank", "width=1000,height=1100");
  if (!w) return;
  w.document.write(html);
  w.document.close();
  setTimeout(() => { w.focus(); w.print(); }, 350);
}
